/* B1G1 duplicate-line fix (18 Sep 2026).
   Shopify splits a cart line when a Buy-X-Get-Y discount frees part of its
   quantity, so one variant renders as two rows. This collapses those rows
   back into one, shows the real quantity and the free count, and makes
   remove clear every line of the variant. Fails safe: if anything is
   unexpected it does nothing and the cart renders as Shopify sent it. */
(function(){
'use strict';
var ROW_SEL='.line-item,.ft-cart__item,.ft-drawer-line-item';
var busy=false;

function money(cents){
  var v=(cents||0)/100;
  try{ return 'LE '+v.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  catch(e){ return 'LE '+v.toFixed(2); }
}

function rowSets(){
  var all=[].slice.call(document.querySelectorAll(ROW_SEL));
  var keys=[],sets=[];
  all.forEach(function(r){
    try{ if(r.parentNode&&r.parentNode.closest&&r.parentNode.closest(ROW_SEL))return; }catch(e){}
    var p=r.parentElement; if(!p)return;
    var i=keys.indexOf(p); if(i<0){keys.push(p);sets.push([]);i=keys.length-1;}
    sets[i].push(r);
  });
  return sets;
}

function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'}).then(function(r){return r.json();}); }
function change(key,qty){
  return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})});
}

function clearVariant(vid){
  if(busy)return; busy=true;
  var step=function(n){
    if(n>8){ location.reload(); return; }
    getCart().then(function(c){
      var hit=null;
      (c.items||[]).forEach(function(i){ if(!hit && String(i.variant_id)===String(vid)) hit=i; });
      if(!hit){ location.reload(); return; }
      change(hit.key,0).then(function(){ step(n+1); }).catch(function(){ location.reload(); });
    }).catch(function(){ location.reload(); });
  };
  step(0);
}

function collapse(cart){
  if(!cart||!cart.items||!cart.items.length)return;
  rowSets().forEach(function(rows){ if(rows.length===cart.items.length) collapseIn(rows,cart); });
}

function collapseIn(rows,cart){
  var groups={},order=[];
  cart.items.forEach(function(it,i){
    var k=String(it.variant_id);
    if(!groups[k]){groups[k]={vid:k,rows:[],qty:0,paid:0,free:0};order.push(k);}
    groups[k].rows.push(rows[i]);
    groups[k].qty+=it.quantity;
    groups[k].paid+=it.final_line_price;
    if(it.final_line_price===0) groups[k].free+=it.quantity;
  });
  order.forEach(function(k){
    var g=groups[k];
    if(g.rows.length<2)return;
    if(g.rows[0].getAttribute('data-gs-merged'))return;
    for(var i=1;i<g.rows.length;i++){ g.rows[i].style.display='none'; g.rows[i].setAttribute('data-gs-hidden','1'); }
    var keep=g.rows[0];
    keep.setAttribute('data-gs-merged','1');
    var qtyBox=keep.querySelector('[class*="qty"],[class*="quantity"]');
    if(qtyBox){
      var lab=document.createElement('div');
      lab.setAttribute('data-gs-qty','1');
      lab.style.cssText='display:inline-block;border:1px solid #dcdcdc;border-radius:999px;padding:7px 16px;font:500 13px/1 inherit;white-space:nowrap';
      lab.textContent='Qty '+g.qty;
      qtyBox.parentNode.replaceChild(lab,qtyBox);
    }
    if(g.free>0){
      var priceEl=null, cands=keep.querySelectorAll('[class*="price"]');
      for(var p=0;p<cands.length;p++){ if(/\d/.test(cands[p].textContent)){ priceEl=cands[p]; break; } }
      if(priceEl && !priceEl.querySelector('[data-gs-merged-price]')){
        priceEl.innerHTML='<span data-gs-merged-price="1">'+money(g.paid)+
          '<span style="display:block;font:600 11px/1.5 ui-monospace,SFMono-Regular,Menlo,monospace;letter-spacing:.06em;color:#12703b">'+
          g.free+' FREE &mdash; OFFER APPLIED</span></span>';
      }
    }
    var rm=keep.querySelector('[class*="remove"]');
    if(rm){
      var c2=rm.cloneNode(true);
      c2.removeAttribute('href'); c2.style.cursor='pointer';
      rm.parentNode.replaceChild(c2,rm);
      c2.addEventListener('click',function(ev){ ev.preventDefault(); ev.stopPropagation(); clearVariant(g.vid); },true);
    }
  });
}

function run(){
  try{
    if(busy)return;
    if(!/\/cart/.test(location.pathname) && !document.querySelector('.cart-drawer__body-content,.ft-cart__items')) return;
    getCart().then(collapse).catch(function(){});
  }catch(e){}
}
document.addEventListener('DOMContentLoaded',function(){setTimeout(run,700);});
setTimeout(run,1400);
var _f2=window.fetch;
window.fetch=function(){var a=arguments,pr=_f2.apply(this,a);
  try{var u=(typeof a[0]==='string')?a[0]:(a[0]&&a[0].url)||'';
    if(/\/cart\/(add|change|update|clear)/.test(u)) pr.then(function(){setTimeout(run,600);});}catch(e){}
  return pr;};
var mo2=new MutationObserver(function(){clearTimeout(window.__gsMerge);window.__gsMerge=setTimeout(run,500);});
if(document.body) mo2.observe(document.body,{childList:true,subtree:true});
})();
